var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSimp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.708 5L10 9.292 9.292 10 5 5.708.708 10 0 9.292 4.292 5 0 .708.708 0 5 4.292 9.292 0 10 .708 5.708 5z",
    fill: "#7D8085"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzA4MDEgNUwxMCA5LjI5MTk5TDkuMjkxOTkgMTBMNSA1LjcwODAxTDAuNzA4MDA4IDEwTDAgOS4yOTE5OUw0LjI5MTk5IDVMMCAwLjcwODAwOEwwLjcwODAwOCAwTDUgNC4yOTE5OUw5LjI5MTk5IDBMMTAgMC43MDgwMDhMNS43MDgwMSA1WiIgZmlsbD0iIzdEODA4NSIvPgo8L3N2Zz4K";
export { SvgCloseSimp as ReactComponent };